import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  Table,
  Button,
  Dialog,
  Form,
  Select,
  Input,
  Message,
  CascaderSelect,
  DatePicker,
} from '@alifd/next';

import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import 'antd/dist/antd.css';
import BarcodeReader from 'react-barcode-reader';
import axios from 'axios';

const { Item } = Form;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const PostalserviceReceive = (props) => {
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const users = client.service('users');
  const postalRegistration = client.service('postalRegistration');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [scanArr, setScanArr] = useState([]);
  const [registrationArr, setRegistrationArr] = useState([]);

  const [correspondenceArr, setCorrespondenceArr] = useState([]);
  const [household, setHousehold] = useState('');
  const [householdNumber, setHouseholdNumber] = useState('');
  const [floor, setFloor] = useState('');
  const [floorChild, setFloorChild] = useState('');
  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfidDialog, setRfidDialog] = useState(false);
  const [rfidDisplay, setRfidDisplay] = useState('');
  const [receiveNowDialog, setReceiveNowDialog] = useState(false);
  const [receiveNowValue, setReceiveNowValue] = useState('');
  const [receiveBuildValue, setReceiveBuildValue] = useState('');
  const [status, setStatus] = useState('');
  const [order, setOrder] = useState('');

  // search
  const [selectDate, setSelectDate] = useState('');
  const [householdArr, setHouseholdArr] = useState('');

  // webcam
  const [webcamRun, setWebcamRun] = useState(false);
  const [webcamDialog, setWebcamDialog] = useState(false);
  const [webcamEditDialog, setWebcamEditDialog] = useState(false);
  const webcamRef = useRef(null);
  const [residentPhoto, setResidentPhoto] = useState(null);

  const [devices, setDevices] = useState([]);
  // console.log(devices);
  const [devicesVal, setDevicesVal] = useState('');
  const foundDevicesArr = [];
  const foundDevicesResult = devices.find(({ label }) => label === devicesVal);
  foundDevicesArr.push(foundDevicesResult);

  // console.log(foundDevicesArr)

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    // console.log(imageSrc)
    setResidentPhoto(imageSrc);
  }, [webcamRef, setResidentPhoto]);
  // console.log(residentPhoto)

  async function getWebcam() {
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    const devices = await navigator.mediaDevices.enumerateDevices();
    setDevices(devices.filter(({ kind }) => kind === 'videoinput'));
  }

  // receive
  const [receiveDialog, setReceiveDialog] = useState(false);
  const [receiveIndex, setReceiveIndex] = useState('');

  // receiveProps
  const [checkState, setCheckState] = useState(false);

  const [receiveId, setReceiveId] = useState('');

  // residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  // 戶號選單
  function accountNumbersOption() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      let objBuilding = dataSource.find((item) => item.label === building);
      if (!objBuilding) {
        objBuilding = {
          value: `${building}`,
          label: `${building}`,
          children: [],
        };
        dataSource.push(objBuilding);
      }
      // 第二層
      const floor = residentAccountNumbersArr[i].floor;
      let objFloor = objBuilding.children.find((item) => item.label === floor);
      if (!objFloor) {
        objFloor = {
          value: `${building}-${floor}`,
          label: `${floor}`,
          children: [],
        };
        objBuilding.children.push(objFloor);
      }

      // 第三層
      const floorChild = residentAccountNumbersArr[i].floorChild;
      let objFloorChild = dataSource.find((item) => item.label === floorChild);
      if (!objFloorChild) {
        objFloorChild = {
          value: `${building}-${floor}-${floorChild}`,
          label: `${floorChild}`,
        };
        objFloor.children.push(objFloorChild);
      }
      // console.log(`==${i}th dataSource:`,dataSource)
    }
    return dataSource;
  }

  // 棟別選單
  function accountNumbersBuildOption() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      let objBuilding = dataSource.find((item) => item.label === building);
      if (!objBuilding) {
        objBuilding = {
          value: `${building}`,
          label: `${building}`,
        };
        dataSource.push(objBuilding);
      }
    }
    return dataSource;
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }

  // search

  function search() {
    if (!selectDate && !receiveBuildValue) {
      Message.error('二個選單都要填寫');
      return;
    }
    if (!selectDate) {
      Message.error('二個選單都要填寫');
      return;
    }
    if (!receiveBuildValue) {
      Message.error('二個選單都要填寫');
      return;
    }

    if (selectDate === 'currentDay') {
      const DAY_MS = 24 * 60 * 60 * 1000;

      postalRegistration
        .find({
          query: {
            createdTime: {
              $gt: new Date().getTime() - DAY_MS,
            },
            status: '未領取',
            findBuild: `${receiveBuildValue}`,
          },
        })
        .then((res) => {
          console.log('==postalRegistration find data success:', res.data);
          setRegistrationArr(res.data.sort(ordersort));

          Message.success('查詢成功');
        })
        .catch((error) => {
          console.log('==postalRegistration find data fail:', error);
          Message.success('查無包裹');
        });
    }

    if (selectDate === 'currentWeekDay') {
      const DAY_MS = 24 * 60 * 60 * 1000 * 7;

      postalRegistration
        .find({
          query: {
            createdTime: {
              $gt: new Date().getTime() - DAY_MS,
            },
            status: '未領取',
            findBuild: `${receiveBuildValue}`,
          },
        })
        .then((res) => {
          console.log('==postalRegistration find data success:', res.data);
          setRegistrationArr(res.data.sort(ordersort));
          Message.success('查詢成功');
        })
        .catch((error) => {
          console.log('==postalRegistration find data fail:', error);
          Message.success('查無包裹');
        });
    }
    if (selectDate === 'currentMonthDay') {
      const DAY_MS = 24 * 60 * 60 * 1000 * 30;

      postalRegistration
        .find({
          query: {
            createdTime: {
              $gt: new Date().getTime() - DAY_MS,
            },
            status: '未領取',
            findBuild: `${receiveBuildValue}`,
          },
        })
        .then((res) => {
          console.log('==postalRegistration find data success:', res.data);
          setRegistrationArr(res.data.sort(ordersort));
          Message.success('查詢成功');
        })
        .catch((error) => {
          console.log('==postalRegistration find data fail:', error);
          Message.success('查無包裹');
        });
    }
  }
  return (
    <>
      <h1>查詢未領取包裹</h1>
      <div className={styles.findPackage}>
        <h2>選擇日期</h2>
        <Select
          className={styles.packageTime}
          placeholder="請選擇日期"
          onChange={(value) => {
            // console.log(value)
            setSelectDate(value);
          }}
        >
          <Option value="currentDay">一天內</Option>
          <Option value="currentWeekDay">一週內</Option>
          <Option value="currentMonthDay">三十天內</Option>
        </Select>

        <h2 className={styles.packageTime}>選擇棟別</h2>
        <CascaderSelect
          className={styles.packageTime}
          placeholder="請選擇棟別"
          dataSource={accountNumbersBuildOption()}
          // value={receiveBuildValue}
          onChange={(value) => {
            setReceiveBuildValue(value);
          }}
        />

        <Button type="secondary" className={styles.packageBtn} onClick={search}>
          搜尋
        </Button>
        <Button
          type="primary"
          className={styles.packageBtn}
          onClick={() => {
            const householdArr = registrationArr.map((item) => item.household);
            const householdNotRepeatingArr = [...new Set(householdArr)];
            // console.log(householdNotRepeatingArr)
            axios('/ezcon/api/emitMsgQuery', {
              method: 'POST',
              headers: { authorization: window.localStorage['feathers-jwt'] },
              data: {
                service: 'message',
                event: 'msg',
                title: '包裹通知',
                content: '包裹來嘍 趕快來領取!!',
                type: 'success',
                class: 'postal',
                duration: 8000,
                redirect: '/ezpro/postal/postalSearch',
                query: {
                  householdNumbers: { $in: householdNotRepeatingArr },
                  firebaseClass: '郵件包裹',
                },
              },
            })
              .then((res) => {
                console.log('==send message Success:', res);
              })
              .catch((error) => {
                console.error('==send message fail:', error);
              });
          }}
        >
          一鍵通知住戶
        </Button>
      </div>

      <h1>請選擇掃描類別</h1>
      <div className={styles.imgContainer}>
        <div>
          <img
            className={styles.img}
            width={300}
            height={200}
            src="https://i.ibb.co/WBXmB6k/75987b6db783b1aebfc550ec1afb84ef.jpg"
            type="cover"
            style={{ border: '1px solid #ccc', margin: '10px' }}
            onClick={() => {
              setBarcodeDialog(true);
              // setHouseholdNumber(scanArr[index].householdNumber);
            }}
          />
          <div>條碼值:{barcodeDisplay}</div>
        </div>
        <Dialog
          hasMask
          className={styles.barcodeDialog}
          visible={barcodeDialog}
          footer={false}
          onClose={() => {
            setBarcodeDialog(false);
          }}
        >
          <div>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (!regex.test(data)) {
                  Message.error('掃描失敗，僅能數字和英文');
                  return;
                }
                users
                  .find({
                    query: {
                      barcodeType: data,
                    },
                  })
                  .then((res) => {
                    console.log(
                      '==users householdNumber find barcodeType success:',
                      res.data[0].householdNumbers
                    );
                    // 檢查是否有此條碼(注意若送出成功沒資料 有可能是別戶的條碼 但不會有資料)
                    if (res.data.length > 0 && regex.test(data)) {
                      // 找到郵務包裹哪個住戶
                      postalRegistration
                        .find({
                          query: {
                            household: { $in: res.data[0].householdNumbers },
                          },
                        })
                        .then((res) => {
                          console.log(
                            '==postalRegistration find household success:',
                            res.data
                          );

                          setRegistrationArr(res.data.sort(ordersort));
                          Message.success('掃描成功');
                          setBarcodeDialog(false);
                        })
                        .catch((error) => {
                          console.log(
                            '==postalRegistration find household fail:',
                            error
                          );
                        });
                    }
                  })
                  .catch((error) => {
                    setBarcodeDialog(true);
                    Message.error('無此條碼');
                    console.log(
                      '==users householdNumber find barcodeType fail:',
                      error
                    );
                  });
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item style={{ width: '300px' }}>
              <Input
                placeholder="自行輸入條碼 Enter確認"
                value={barcodeDisplay}
                onChange={(value) => {
                  setBarcodeDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (!regex.test(barcodeDisplay)) {
                    Message.error('掃描失敗，僅能數字和英文');
                    return;
                  }
                  users
                    .find({
                      query: {
                        barcodeType: barcodeDisplay,
                      },
                    })
                    .then((res) => {
                      console.log(
                        '==users householdNumber find barcodeType success:',
                        res.data[0].householdNumbers
                      );
                      // 檢查是否有此條碼(注意若送出成功沒資料 有可能是別戶的條碼 但不會有資料)
                      if (res.data.length > 0 && regex.test(barcodeDisplay)) {
                        // 找到郵務包裹哪個住戶
                        postalRegistration
                          .find({
                            query: {
                              household: { $in: res.data[0].householdNumbers },
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==postalRegistration find household success:',
                              res.data
                            );
                            setRegistrationArr(res.data.sort(ordersort));
                            Message.success('掃描成功');
                            setBarcodeDialog(false);
                          })
                          .catch((error) => {
                            console.log(
                              '==postalRegistration find household fail:',
                              error
                            );
                          });
                      }
                    })
                    .catch((error) => {
                      setBarcodeDialog(true);
                      Message.error('無此條碼');
                      console.log(
                        '==users householdNumber find barcodeTyp fail:',
                        error
                      );
                    });
                }}
              />
            </Item>
            <img
              className={styles.barcode}
              src="https://i.ibb.co/WBXmB6k/75987b6db783b1aebfc550ec1afb84ef.jpg"
              alt="barcode"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描條碼...</h1>
          </div>
        </Dialog>
        <div>
          <img
            className={styles.img}
            width={300}
            height={200}
            src="https://i.ibb.co/2YzKwKh/2020-11-02-1-20-18.png"
            type="cover"
            style={{ border: '1px solid #ccc', margin: '10px' }}
            onClick={() => {
              setRfidDialog(true);
            }}
          />
          <div>磁扣值:{rfidDisplay}</div>
        </div>
        <Dialog
          hasMask
          className={styles.barcodeDialog}
          visible={rfidDialog}
          footer={false}
          onClose={() => {
            setRfidDialog(false);
          }}
        >
          <div>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (!regex.test(data)) {
                  Message.error('掃描失敗，僅能數字和英文');
                  return;
                }
                users
                  .find({
                    query: {
                      rfidType: data,
                    },
                  })
                  .then((res) => {
                    console.log(
                      '==users householdNumber find barcodeType success:',
                      res.data[0].householdNumbers
                    );
                    // 檢查是否有此條碼(注意若送出成功沒資料 有可能是別戶的條碼 但不會有資料)
                    if (res.data.length > 0 && regex.test(data)) {
                      // 找到郵務包裹哪個住戶
                      postalRegistration
                        .find({
                          query: {
                            household: { $in: res.data[0].householdNumbers },
                          },
                        })
                        .then((res) => {
                          console.log(
                            '==postalRegistration find household success:',
                            res.data
                          );
                          setRegistrationArr(res.data.sort(ordersort));
                          Message.success('掃描成功');
                          setRfidDialog(false);
                        })
                        .catch((error) => {
                          console.log(
                            '==postalRegistration find household fail:',
                            error
                          );
                        });
                    }
                  })
                  .catch((error) => {
                    setRfidDialog(true);
                    Message.error('無此條碼');
                    console.log(
                      '==users householdNumber find barcodeTyp fail:',
                      error
                    );
                  });
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item style={{ width: '300px' }}>
              <Input
                placeholder="自行輸入條碼 Enter確認"
                value={rfidDisplay}
                onChange={(value) => {
                  setRfidDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (!regex.test(rfidDisplay)) {
                    Message.error('掃描失敗，僅能數字和英文');
                    return;
                  }
                  users
                    .find({
                      query: {
                        rfidType: rfidDisplay,
                      },
                    })
                    .then((res) => {
                      console.log(
                        '==users householdNumber find barcodeType success:',
                        res.data[0].householdNumbers
                      );
                      // 檢查是否有此條碼(注意若送出成功沒資料 有可能是別戶的條碼 但不會有資料)
                      if (res.data.length > 0 && regex.test(rfidDisplay)) {
                        // 找到郵務包裹哪個住戶
                        postalRegistration
                          .find({
                            query: {
                              household: { $in: res.data[0].householdNumbers },
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==postalRegistration find household success:',
                              res.data
                            );
                            setRegistrationArr(res.data.sort(ordersort));
                            Message.success('掃描成功');
                            setRfidDialog(false);
                          })
                          .catch((error) => {
                            console.log(
                              '==postalRegistration find household fail:',
                              error
                            );
                          });
                      }
                    })
                    .catch((error) => {
                      setRfidDialog(true);
                      Message.error('無此條碼');
                      console.log(
                        '==users householdNumber find barcodeTyp fail:',
                        error
                      );
                    });
                }}
              />
            </Item>

            <img
              className={styles.barcode}
              src="https://i.ibb.co/2YzKwKh/2020-11-02-1-20-18.png"
              alt="rfid"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描磁扣/卡片...</h1>
          </div>
        </Dialog>

        <div>
          <img
            className={styles.img}
            width={300}
            height={200}
            src="https://i.ibb.co/L17jrvd/2020-10-29-11-08-07.png"
            type="cover"
            style={{ border: '1px solid #ccc', margin: '10px' }}
            onClick={() => {
              setReceiveNowValue('');
              setReceiveBuildValue('');
              setResidentPhoto('');
              setReceiveNowDialog(true);
            }}
          />
          <div>值:{receiveNowValue || receiveBuildValue}</div>
        </div>
        <Dialog
          hasMask
          className={styles.barcodeDialog}
          visible={receiveNowDialog}
          footer={false}
          onClose={() => {
            setReceiveNowDialog(false);
          }}
        >
          <div className={styles.householdAndphoteBox}>
            <Item label="戶號">
              <CascaderSelect
                placeholder="請選擇戶號"
                dataSource={accountNumbersOption()}
                value={receiveNowValue}
                onChange={(value, data, extra) => {
                  setReceiveNowValue(
                    extra.selectedPath.map((item) => item.label).join('-')
                  );
                  setReceiveBuildValue('');
                }}
              />
            </Item>

            <Item label="棟別" style={{ marginLeft: '10px' }}>
              <CascaderSelect
                placeholder="請選擇棟別"
                dataSource={accountNumbersBuildOption()}
                value={receiveBuildValue}
                onChange={(value) => {
                  setReceiveBuildValue(value);
                  setReceiveNowValue('');
                }}
              />
            </Item>
          </div>

          <img
            className={styles.barcode}
            src="https://i.ibb.co/L17jrvd/2020-10-29-11-08-07.png"
            alt="receive"
            type="cover"
            width={400}
            height={300}
          />

          <h1>
            {receiveNowValue || receiveBuildValue
              ? receiveNowValue || receiveBuildValue
              : '請選擇戶號或棟別...'}
          </h1>
          <Button
            className={styles.householdNumberSend}
            type="secondary"
            onClick={() => {
              if (receiveNowValue) {
                postalRegistration
                  .find({ query: { household: receiveNowValue } })
                  .then((res) => {
                    console.log(
                      '==postalRegistration find household success:',
                      res.data
                    );
                    setRegistrationArr(res.data.sort(ordersort));
                    Message.success('查詢成功');
                    setReceiveNowDialog(false);
                    // setReceiveNowValue(receiveNowValue);
                  })
                  .catch((error) => {
                    console.log(
                      '==postalRegistration find household fail:',
                      error
                    );
                    Message.success('查無此戶號');
                  });
              }

              if (receiveBuildValue) {
                // console.log("==receiveBuildValue:",  receiveBuildValue)

                postalRegistration
                  .find({
                    query: { findBuild: receiveBuildValue },
                  })
                  .then((res) => {
                    console.log(
                      '==postalRegistration find household success:',
                      res.data
                    );
                    setRegistrationArr(res.data.sort(ordersort));
                    Message.success('查詢成功');
                    setReceiveNowDialog(false);
                    // setReceiveNowValue(receiveNowValue);
                  })
                  .catch((error) => {
                    console.log(
                      '==postalRegistration find household fail:',
                      error
                    );
                    Message.success('查無此戶號');
                  });
              }
            }}
          >
            確定
          </Button>
        </Dialog>
      </div>

      <Table
        dataSource={registrationArr}
        primaryKey="_id"
        // rowSelection={rowSelectionValue.rowSelection}
      >
        <Table.Column title="編號" dataIndex="order" width={100} />
        <Table.Column title="條碼" dataIndex="barcode" width={200} />
        <Table.Column title="包裹類型" dataIndex="packageType" width={150} />
        <Table.Column title="資訊" dataIndex="information" width={70} />
        <Table.Column title="戶號" dataIndex="household" width={150} />
        <Table.Column title="收件人" dataIndex="recipient" width={150} />
        <Table.Column title="廠商" dataIndex="vendor" width={200} />
        <Table.Column title="物流" dataIndex="logistics" width={200} />
        <Table.Column title="擺放位置" dataIndex="placement" width={200} />
        <Table.Column title="備註" dataIndex="remarks" width={150} />
        <Table.Column
          title="包裹收件時間"
          width={200}
          cell={(value, index, record) => {
            return (
              <>{new Date(record.packagerRegistrationTime).toLocaleString()}</>
            );
          }}
        />
        <Table.Column
          title="住戶領取時間"
          dataIndex="receiveTime"
          width={150}
        />
        <Table.Column title="狀態" width={150} dataIndex="status" />
      </Table>
    </>
  );
};

export default PostalserviceReceive;
